import { IMemberEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SET_REORDERED_MEMBER_INDEX",
    function setReorderedMemberIndex(
        member: IMemberEntity,
        index: number) {
        member.index = index;
    }
);